module.exports = __webpack_public_path__ + "img/组 128@2x(1).a9ced117.png";